<template>
  <div>
    <van-row class="bmTitle">
      <van-col span="24">
        <h2>报名信息</h2>
      </van-col>
    </van-row>
    <van-row class="bmForm">
      <van-col span="24">
        <div class="formInput"><van-field label="姓名" :value="name" readonly /></div>
        <div class="formInput"><van-field label="手机号" :value="phone" readonly /></div>
        <div class="formInput" v-if="key!=='省份' && key!=='报名表附件' && key!=='是否预订酒店'" v-for="(item, key, index) in dtbd"><van-field :label="key" :value="item" readonly /></div>
        <div class="formInput" v-else-if="key=='省份'"><van-field :label="key" :value="province" readonly /></div>
        <div class="formInput" v-else-if="key=='报名表附件'">
          <van-field name="bmtable" :label="key">
            <template #input>
              <van-row gutter="5">
              <van-col span="8" v-for="(item,index) in bmtable" :key="index">
                <a :href="item" target="_blank">
                  <van-image
                    width="100%"
                    height="80"
                    :src="item"
                  />
                </a>
              </van-col>
              </van-row>

            </template>
          </van-field>
        </div>
        <div v-else-if="key=='是否预订酒店'">
          <div class="formInput"><van-field :label="key" :value="item" readonly /></div>
          <div class="formInput" v-for="item,index in ydjd" :key="index"><van-field :label="item.label" :value="item.value" readonly /></div>
        </div>
        <div style="margin:30px 16px 16px;">
          <van-button round block type="info" @click="fhgrzx">返回</van-button>
        </div>
      </van-col>
    </van-row>
  </div>
</template>
<script>
  import Global from '../Global/global.vue';
export default {
  data() {
    return {
      meetingName: '',
      name:'',
      phone:'',
      crtTime:'',
      bmxx:'',
      dtbd:'',
      province:'',
      ydjd:[],
      bmtable:[]
    };
  },
  methods: {

    toEnteredCenter() {
      var domain = window.location.host;
      //设置请求地址
      var http = "";
      if (domain.indexOf('127.0.0.1') > -1 || domain.indexOf('localhost') > -1 || domain.indexOf('meeting.ejectu.com') == 0) {
          //域名
          http = "https://meeting.ejectu.com";
      }

      const hyMeetingId = sessionStorage.getItem('meetingId');
      const token = localStorage.getItem('sessionGrzxToken_'+hyMeetingId);
      if (!token) {
        this.$router.push('/personal/login?meetingId=' + hyMeetingId);
        return false;
      } else {
        this.axios.get('/api/appweb/entered/toEnteredCenter/' + hyMeetingId, { headers: { Authorization: ` ${token}` } }).then(res => {
          // console.log(res.data.data);
          const entered = res.data.data.entered;
          const meeting = res.data.data.meeting;
          this.meetingName = meeting.meetingName;
          this.name = entered.name;
          this.phone = entered.phone;
          this.crtTime = entered.crtTime;
          this.axios.get('/api/appweb/entered/getMeetingFromInfo?code='+meeting.code).then((res)=>{
            const dtmeetingForm = res.data.data.meetingForm;
            const grzxextendParam = JSON.parse(entered.extendParam);
            // console.log(dtmeetingForm);
            var data = {};
            for (let key in dtmeetingForm) {
              for (let key2 in grzxextendParam) {
                 if(dtmeetingForm[key].shortName == key2){
                   data[dtmeetingForm[key].name] = grzxextendParam[key2];

                   if(key2 == 'bmtable'){
                     var bmtableArr = grzxextendParam[key2].split(',');
                     var bmtableMap = {};
                     for (let url in bmtableArr) {
                      console.log(bmtableArr[url]);
                        bmtableMap = http + bmtableArr[url];
                        this.bmtable.push(bmtableMap)
                     }
                   }else if(key2 == 'province'){
                     var valueEnum = JSON.parse(dtmeetingForm[key].defaultValue).valueEnum;
                     for(var key3 in valueEnum){
                       if (key3 == grzxextendParam[key2]) {
                          this.province = valueEnum[key3].text
                       }
                     }
                   }else if(key2 == 'ReAddress'){
                      console.log(grzxextendParam.ReAddress);
                      data[dtmeetingForm[key].name] = grzxextendParam.provinceSelect+'/'+grzxextendParam.citySelect+'/'+grzxextendParam.districtSelect;
                      data[' '] = grzxextendParam.ReAddress;
                   }else if(key2 == 'zjlx'){
                     if(grzxextendParam[key2] =='身份证'){
                      data['证件号码'] = grzxextendParam.cardNum
                     }else if(grzxextendParam[key2] =='军官证'){
                      data['证件号码'] = grzxextendParam.officer
                     }else if(grzxextendParam[key2] =='港澳通行证'){
                      data['证件号码'] = grzxextendParam.HKMpass
                     }else{
                       data['证件号码'] = grzxextendParam.passport
                     }
                   }else if(key2 == 'isYdjd'){
                     if(grzxextendParam.fangXing!=undefined){
                       this.ydjd.push({
                         label:'房型',
                         value:grzxextendParam.fangXing
                       })
                     }
                     if(grzxextendParam.rzldTime!=undefined){
                       this.ydjd.push({
                         label:'入住/离店时间',
                         value:grzxextendParam.rzldTime
                       })
                     }
                   }

                 }
              }
            }
            this.dtbd = data;
            console.log(this.dtbd);
          })
        });
      }
    },
    fhgrzx(){
      this.$router.push('/personal/index')
    }
  },
  mounted(){
    this.toEnteredCenter();
  }
};
</script>

<style scoped="scoped">
.bmForm {
  padding: 20px 0;
}
.bmTitle {
  padding: 0px 20px 10px;
  line-height: 40px;
  background: url(~@/assets/images/titlebg.png) no-repeat bottom center;
  background-size: 100% 100%;
  color: #fff;
  text-align: center;
}
.bmTitle h2 {
  font-weight: normal;
  font-size: 30px;
}
.formInput {
  padding: 4px 0;
  margin: 0 20px;
  border-bottom: 1px solid #e8e8e8;
}
.lineddd {
  height: 3px;
  background-color: #e8e8e8;
  margin-top: -1px;
}
.van-cell,
.van-button {
  font-size: 16px;
}
.van-cell::after {
  border-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Personal/bmxx.vue